import { FieldCacheService, NSARouterMaker, NSARouterMakerResult, NSFRouterMaker } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { EnvService, IStorageSession } from "namirasoft-core";
import { NamirasoftPaymentServer } from "namirasoft-payment";
import { NSNotFoundPage } from "namirasoft-site-react";
import { useReducer } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { PaymentLayout } from "./PaymentLayout";
import { PaymentRoutes } from "./PaymentRoutes";
import HomePage from "./pages/HomePage";
import InvoiceGatewayPage from "./pages/InvoiceGatewayPage";
import InvoiceListPage from "./pages/InvoiceListPage";
import InvoiceViewPage from "./pages/InvoiceViewPage";
import LoginPage from "./pages/LoginPage";
import OfferGatewayPage from "./pages/OfferGatewayPage";
import OfferItemViewPage from "./pages/OfferItemViewPage";
import OfferListPage from "./pages/OfferListPage";
import OfferViewPage from "./pages/OfferViewPage";
import PaymentCanceledPage from "./pages/PaymentCanceledPage";
import PaymentListPage from "./pages/PaymentListPage";
import PaymentSuccessfulPage from "./pages/PaymentSuccessfulPage";
import PaymentViewPage from "./pages/PaymentViewPage";
import ProductListPage from "./pages/ProductListPage";
import SalesItemListPage from "./pages/SalesItemListPage";
import SalesItemViewPage from "./pages/SalesItemViewPage";
import SubscriptionCanceledPage from "./pages/SubscriptionCanceledPage";
import SubscriptionCancellationConfirmationPage from "./pages/SubscriptionCancellationConfirmationPage";
import SubscriptionCancellationOfferPage from "./pages/SubscriptionCancellationOfferPage";
import SubscriptionCancellationPage from "./pages/SubscriptionCancellationPage";
import SubscriptionCancellationResultPage from "./pages/SubscriptionCancellationResultPage";
import SubscriptionListPage from "./pages/SubscriptionListPage";
import SubscriptionSuccessfulPage from "./pages/SubscriptionSuccessfulPage";
import SubscriptionViewPage from "./pages/SubscriptionViewPage";

function Router()
{
    let [, page_force_update] = useReducer((x) => x + 1, 0);

    let navigate = useNavigate();

    return <NSARouterMaker
        notifier_storage={new IStorageSession()}
        page_force_update={page_force_update}
        product_id={ProductUUID.NAMIRASOFT_PAYMENT}

        renderOnLogin={(result: NSARouterMakerResult) =>
        {
            let REACT_APP_BASE_URL_PAYMENT = new EnvService("REACT_APP_BASE_URL_PAYMENT", true).getString();

            let payment = new NamirasoftPaymentServer(REACT_APP_BASE_URL_PAYMENT, result.account.token_manager, result.notifier.onError);

            let servers = { payment };

            return (
                <FieldCacheService
                    {...result}
                    render={(rows) => (
                        <Routes>
                            <Route path={PaymentRoutes.Home} element={<HomePage {...result} servers={servers} />} />

                            <Route path={PaymentRoutes.SubscriptionList(false, "")} element={<SubscriptionListPage {...result} servers={servers} />} />
                            <Route path={PaymentRoutes.SubscriptionView(":id", false, "")} element={<SubscriptionViewPage {...result} servers={servers} />} />
                            <Route path={PaymentRoutes.SubscriptionCancellation(":id", false, "")} element={<SubscriptionCancellationPage {...result} servers={servers} />} />
                            <Route path={PaymentRoutes.SubscriptionCancellationConfirmation(":id", ":cancellation_reason_id", false, "")} element={<SubscriptionCancellationConfirmationPage {...result} servers={servers} />} />
                            <Route path={PaymentRoutes.SubscriptionCancellationResult(":id", false, "")} element={<SubscriptionCancellationResultPage {...result} servers={servers} />} />
                            <Route path={PaymentRoutes.SubscriptionCanceled(":id", false, "")} element={<SubscriptionCanceledPage {...result} servers={servers} />} />
                            <Route path={PaymentRoutes.SubscriptionSuccessful(":id", false, "")} element={<SubscriptionSuccessfulPage {...result} servers={servers} />} />

                            <Route path={PaymentRoutes.InvoiceList(false, "")} element={<InvoiceListPage {...result} servers={servers} />} />
                            <Route path={PaymentRoutes.InvoiceView(":id", false, "")} element={<InvoiceViewPage {...result} servers={servers} />} />
                            <Route path={PaymentRoutes.InvoiceGateway(":id", false, "")} element={<InvoiceGatewayPage {...result} servers={servers} />} />

                            <Route path={PaymentRoutes.PaymentList(false, "")} element={<PaymentListPage {...result} servers={servers} />} />
                            <Route path={PaymentRoutes.PaymentView(":id", false, "")} element={<PaymentViewPage {...result} servers={servers} />} />
                            <Route path={PaymentRoutes.PaymentCanceled(false, "")} element={<PaymentCanceledPage {...result} servers={servers} />} />
                            <Route path={PaymentRoutes.PaymentSuccessful(false, "")} element={<PaymentSuccessfulPage {...result} servers={servers} />} />

                            <Route path={PaymentRoutes.ProductList(false, "")} element={<ProductListPage {...result} servers={servers} />} />

                            <Route path={PaymentRoutes.SalesItemList(":product_slug", false, "")} element={<SalesItemListPage {...result} servers={servers} />} />
                            <Route path={PaymentRoutes.SalesItemView(":id", false, "")} element={<SalesItemViewPage {...result} servers={servers} />} />

                            <Route path={PaymentRoutes.OfferList(":product_slug", ":sales_item_slug", false, "")} element={<OfferListPage {...result} servers={servers} />} />
                            <Route path={PaymentRoutes.OfferListOne(":product_slug", ":sales_item_slug", ":offer_id", false, "")} element={<OfferListPage {...result} servers={servers} />} />
                            <Route path={PaymentRoutes.OfferView(":id", false, "")} element={<OfferViewPage {...result} servers={servers} />} />
                            <Route path={PaymentRoutes.OfferItemView(":id", false, "")} element={<OfferItemViewPage {...result} servers={servers} />} />

                            <Route path={PaymentRoutes.SubscriptionCancellationOffer(":id", ":offer_id", ":cancellation_reason_id", false, "")} element={<SubscriptionCancellationOfferPage {...result} servers={servers} />} />
                            <Route path={PaymentRoutes.OfferGateway(":product_slug", ":sales_item_slug", ":id", false, "")} element={<OfferGatewayPage {...result} servers={servers} />} />

                            {NSFRouterMaker.getRoutes({ ...result, rows, children: <></> })}

                            <Route path="*" element={<NSNotFoundPage />} />
                        </Routes >
                    )}
                />
            );
        }}
        renderOnLogout={() => (
            <Routes>
                <Route path={PaymentRoutes.Home} element={<LoginPage />} />
                <Route path="*" element={<LoginPage />} />
            </Routes>
        )}
        navigate={navigate}
        getNSALayout={(props) => (
            <PaymentLayout {...props}>
                {props.children}
            </PaymentLayout>
        )}
        requirement={{
            verification: {
                email: true,
                phone: false
            }
        }}
    />
}

export default Router;